import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import type { HandleFilterChanged } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterSessionValue } from '@/app/common/filters/session/sessionState.ts';
import type { ResultPageFilterTracking } from '@/app/common/starTrack/events/resultPageFilter.ts';
import { filterTypeOf } from '@/app/common/filters/types/filterTypeBehaviour.ts';

export const normaliseDraftFilters = (filters: Filter[]): Filter[] =>
  filters.map((filter) => filterTypeOf(filter).normaliseDraft?.(filter) ?? filter);

const draftKey = (filter: Filter): string => {
  const { selectedOptions, serialise } = filterTypeOf(filter);
  const values = selectedOptions
    ? selectedOptions(filter)
        .map((option) => option.value)
        .sort()
    : [serialise(filter) ?? ''];

  return [String(filter.name), ...values].join('\0');
};

export const filtersEqual = (a: Filter[], b: Filter[]): boolean => {
  if (a.length !== b.length) return false;

  const keysA = a.map(draftKey).sort();
  const keysB = b.map(draftKey).sort();
  return keysA.every((key, index) => key === keysB[index]);
};

export const commitDraftFilters = (
  draft: Filter[],
  applied: Filter[],
  handleFilterChanged: HandleFilterChanged,
  pressedOrder: FilterSessionValue[],
  tracking?: ResultPageFilterTracking
): void => {
  const normalised = normaliseDraftFilters(draft);
  if (!filtersEqual(normalised, applied)) handleFilterChanged(normalised, pressedOrder, tracking);
};
